import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable, switchMap, take } from 'rxjs';
import { common_urls_cws2 } from 'src/environments/environment';
import { ProcedureBackend } from './procedure-config.constants';

export interface ProcedureConfig {
  name: string;
  enabled: boolean;
  backend: ProcedureBackend;
}

@Injectable({
  providedIn: 'root',
})
export class ProcedureConfigService {
  private readonly httpClient = inject(HttpClient);
  private readonly oidcSecurityService = inject(OidcSecurityService);

  load(name: string): Observable<ProcedureConfig> {
    return this.oidcSecurityService.getAccessToken().pipe(
      take(1),
      switchMap((accessToken) =>
        this.httpClient.post<ProcedureConfig>(
          `${common_urls_cws2.bffBaseUrl_mvp3}/load/procedure-config`,
          { name },
          {
            headers: new HttpHeaders({
              Authorization: `Bearer ${accessToken}`,
              'Content-Type': 'application/json',
            }),
          }
        )
      )
    );
  }
}